import Param from '../param';
let param = new Param();

/* -------------------------------------------------------------------------

    --  [ ※ボディの背景にあるもので自動でアニメーションさせるもの ]

------------------------------------------------------------------------- */

export default class autoAnimationManager {
    constructor(){

        this.status = {
            airplaneStart : false
        }
    }

    car($target,inc){

        // let tl = new TimelineLite();


        for(let i=0; i<$target.length; i++){

            if(!$target[0].classList.contains("is-back")){
                // TweenMax.set($target,{ opacity:1 });
                TweenMax.to($target[0], 5.6,
                    {
                        y:-inc,
                        ease: Power1.easeInOut,
                        onComplete:function () {
                            // TweenMax.set($target,{ opacity:0 });
                            $target[0].classList.add("is-back");
                            setTimeout(function () {
                                // $target.parent(".js__tsc").removeClass("is-show")
                                $target[0].parent[0].classList.remove("is-show")
                            },15e2);
                        }
                        // filter:"blur(0px)",
                        // ease: "Power2.easeOut",
                    }
                );
            }else{
                // TweenMax.set($target,{ opacity:1 });
                TweenMax.to($target[i], 5.6,
                    {
                        y:0,
                        ease: Power1.easeInOut,
                        onComplete:function () {
                            $target[i].classList.add("is-front");
                            // TweenMax.set($target,{ opacity:0 });
                            setTimeout(function () {
                                $target[i].classList.remove("is-front");
                                $target[i].classList.remove("is-back");
                                // $target.parent(".js__tsc").removeClass("is-show")
                                $target[i].parent[0].classList.remove("is-show")
                            },15e2);
                        }
                        // filter:"blur(0px)",
                        // ease: "Power2.easeOut",
                    }
                );
            }

        }

    }
    airplane($target,inc){


        if(this.status.airplaneStart) return;

        this.status.airplaneStart = true;


        TweenMax.to($target[0], 16.6 / Number($target[0].getAttribute("data-speed")),
            {
                y:-window.innerHeight*2,
                z:0,
                ease: Power1.easeInOut,
            }
        );

        // TweenMax.fromTo($target[0], 10.6 / Number($target[0].getAttribute("data-speed")),
        //     {
        //         y:window.innerHeight,
        //         z:1,
        //     },
        //     {
        //         y:-window.innerHeight,
        //         z:0,
        //         ease: Power1.easeInOut,
        //         // repeat : -1,
        //         onComplete:function () {
        //             // setTimeout(function () {
        //             //     // $target[0].parent(".js__tsc").removeClass("is-show")
        //             //     $target[i].parent[0].classList.remove("is-show")
        //             // },15e2);
        //         }
        //     }
        // );

        // for(let i=0; i<$target.length; i++){
        //
        //
        // }


    }


}
